// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"fca06845","51":"ee4e7a57","751":"f8f0d57a"}[chunkId] + ".chunk.js";
};